var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMillustrationsNginx = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 40,
  fill: "none",
  viewBox: "0 0 56 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 23,
  x: 8.5,
  y: 8.5,
  fill: "#fff",
  stroke: "#CCCCD9",
  rx: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8A8A99",
  fillRule: "evenodd",
  d: "M22.367 23.537a.7.7 0 0 1-.268-.26.66.66 0 0 1-.099-.361v-6.278c0-.261.134-.501.367-.629l5.438-3.135a.7.7 0 0 1 .72 0l5.438 3.135c.226.128.36.368.36.629v6.27a.72.72 0 0 1-.36.63l-5.438 3.135a.7.7 0 0 1-.72 0zm3.355-.67c.388 0 .699-.311.699-.7v-3.474l3.135 3.743c.233.29.622.424.954.424.459 0 .79-.304.79-.678v-4.795c0-.389-.31-.7-.699-.7s-.699.311-.699.7v3.481l-2.923-3.495-.212-.255c-.233-.29-.622-.423-.953-.423-.46 0-.791.303-.791.678v4.795c0 .388.31.699.699.699",
  clipRule: "evenodd"
})));
export default SvgMillustrationsNginx;